import './index.less'
import { useEffect, useState } from 'react';
import { getPlainText } from '@/utils';
import { getQuestionUserList } from '@/api/user'
import { useNavigate } from 'react-router-dom'
import { Empty, Pagination } from 'antd';
import useThumbsUp from '../../hooks/useThumbsUp';


const MyQuestion = () => {
  const navigate = useNavigate();
  const [questionList, setQuestionList] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [total, setTotal] = useState(0);
  const { handleThumbsUp } = useThumbsUp();

  const viewDetail = (sourceId: string, type: 'UGC' | 'FAQ' | 'NOTICE') => {
    const typeMap = {
      UGC: 'feedback',
      FAQ: 'faq',
      NOTICE: 'notice',
    };
    navigate(`/technicalSupport/${typeMap[type]}Detail/${sourceId}`);
  }
  const getMyQuestions = async(page: number) => {
    const res = await getQuestionUserList({
      pageNumber: page,
      pageSize: 5,
    })
    if (res?.code === 200) {
      setQuestionList(res.result.records);
      setTotal(res.result.total);
      setPageNumber(res.result.current);
    }
  }
  const paginationChange = (page: number) => {
    getMyQuestions(page);
  };
  useEffect(() => {
    getMyQuestions(1)
  }, [])
  return <div className="my-question">
    <div className='my-question-title'>我的问题</div>
    <div className='my-question-main'>
      {
        questionList.length === 0 ?  <div className='empty-content'>
          <Empty description="暂无数据" />
        </div> : null
      }
      {
        questionList.map((item: any) => {
          return <div className='question-item' key={item.id}>
            <div onClick={() => viewDetail(item.id, item.bizType)}>{item.overview || item.title}</div>
            <div onClick={() => viewDetail(item.id, item.bizType)}>{getPlainText(item?.description || item?.content)}</div>
            <div>
              <span>{item.createTime}</span>
              <div className='operate-box'>
                <span onClick={() => handleThumbsUp(item.bizType, item.id, item.currentUserIsThumbsUp, setQuestionList)}>
                  <img src={item.currentUserIsThumbsUp ? require('@/assets/images/support/avport.png') : require('@/assets/images/support/no-avport.png')} alt="" />
                  {item.thumbsUpCount}
                </span>
                <span>
                  <img src={require('@/assets/images/support/look.png')} alt="" />
                  {item.viewCount}
                </span>
              </div>
            </div>
          </div>
        })
      }
      {
        total > questionList.length && <Pagination
          pageSize={5}
          current={pageNumber}
          showSizeChanger={false}
          total={total}
          rootClassName="pagination"
          onChange={paginationChange}
        />
      }
    </div>
  </div>
}

export default MyQuestion;